import React from "react";
import fetch from "isomorphic-fetch";
import { Grid, Icon, Cell } from "react-mdl";

import "./style.css";

export default class Account extends React.Component {

  state = {
    error_occurred: false,
    not_found: false,
    saves: []
  };

  componentDidMount() {
    // Load account data.
    this.loadAccount();
  }

  loadAccount() {
    const accountName = encodeURIComponent(this.props.params.name);
    fetch(
      process.env.API_URL + `/armory/api/account?account=${accountName}`
    )
    .then((response) => {
      if (response.status === 404) {
        throw new Error("Not found");
      } else if (response.status > 404) {
        throw new Error("Something went terribly wrong");
      }
      return response.json();
    })
    .then((response) => {
      if (response.characters) {
        this.setState({
          saves: response.characters
        });
      } else {
        this.setState({
          error_occurred: true,
        });
      }
    })
    .catch((e) => {
      if (e.message === "Not found") {
        this.setState({
          not_found: true,
        });
      } else {
        this.setState({
          error_occurred: true,
        });
      }
    });
  }

  render() {
    if (this.state.not_found) {
      document.title = "Account not found";
      return (
        <div className="broadcast">
          <Icon name="power" />
          <h1 className="broadcast-text">
            Account does not exist.
          </h1>
        </div>
      );
    }

    if (this.state.error_occurred) {
      document.title = "Parsing error";
      return (
        <div className="broadcast">
          <Icon name="adb" />
          <h1 className="broadcast-text">
            Couldn't get account data, please notify this on Discord.
          </h1>
        </div>
      );
    }

    document.title = `${this.props.params.name}'s saves`;

    return (
      <div>
        <Grid className="menu-grid">
          <Cell col={12} tablet={12} phone={12}>
            <ul className="menu">
              <li>
                <a
                  title="Checkout the discord"
                  href="http://www.diablo09.com/discord/"
                >
                  <Icon name="timeline" />
                  <span>DISCORD</span>
                </a>
              </li>
              <li>
                <a title="Search the armory" href="/">
                  <Icon name="search" />
                  <span>SEARCH</span>
                </a>
              </li>
              <li>
                <a
                  title="Diablo 09 subreddit"
                  href="https://www.reddit.com/r/Diablo09/"
                >
                  <Icon name="comment" />
                  <span>REDDIT</span>
                </a>
              </li>
            </ul>
          </Cell>
        </Grid>
        <Grid className="saves-sheet profile-top">
          <Cell col={12} tablet={12} phone={12}>
            <h1 className="account-name underlined">{this.props.params.name}'s saves</h1>

            {(this.state.saves.length > 0) ?
              <ul>
                {this.state.saves.map((save, i) =>
                  <li key={`${save}_${i}}`}>
                    <div className="save-details">
                      <img src={`${process.env.PUBLIC_URL}/assets/pentagram_small.png`} role="presentation" />
                      <a className="save" href={`${process.env.PUBLIC_URL}/character/${save}`}>{save}</a>
                    </div>
                  </li>
                )}
              </ul>
              :
              <h2 className="no-saves">Account does not exist or it does not have any character saves</h2>
            }

          </Cell>

        </Grid>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/account/index.js